React = require 'react'
Util = require 'lib/util'
l = require 'lib/localize'
# Using `board_menu_vis` here to share strings from old template
t = require('views/internal/recup-with-helpers')()
{ parseUserLink } = require 'network/unsplash'

module.exports = class PhotoAttributionComponent extends React.Component
  displayName: 'PhotoAttributionComponent'

  render: t.renderable ->
    { user, size, active } = @props

    text = user.name

    classNames = ['.photo-attribution-component']
    if size?
      classNames.push ".#{size}"

    if active?
      classNames.push '.photo-attribution-component--active'
      text = l(['background photos', 'photo by']) + " " + user.name

    t.div classNames.join(''), ->
      t.a {
        class: 'photo-attribution-component-attribution-link'
        href: parseUserLink(user.links.html)
        target: '_blank'
        title: user.name
        onClick: (e) -> e.stopPropagation()
      }, ->
        t.text text



// WEBPACK FOOTER //
// ./app/scripts/views/board-create/photo-attribution-component.coffee